import { render } from "./create-supplier.vue?vue&type=template&id=58d92c26&scoped=true"
import script from "./create-supplier.vue?vue&type=script&lang=js"
export * from "./create-supplier.vue?vue&type=script&lang=js"

import "./create-supplier.vue?vue&type=style&index=0&id=58d92c26&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d92c26"]])

export default __exports__